import { render } from "./SessaoListDialog.vue?vue&type=template&id=2968ce86"
import script from "./SessaoListDialog.vue?vue&type=script&lang=js"
export * from "./SessaoListDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__